import { useEffect, useContext } from 'react';
import ToastContext from 'src/store/toast-context';
import { useLoaded } from 'src/store/load-context';
import LeasedAssetDataTable from 'src/components/section/LeasedAssetDataTable';
import { useAPI } from 'src/services/api';
import CardWrapper from 'src/components/util/CardWrapper';
import handleNull from 'src/util/handleNull';
import LeasedAssetContext from 'src/store/leased-asset-table-context';
import InstructionsList from 'src/components/InstructionsList';

const LeasedAssetPage = () => {
  const api = useAPI();
  const { handleError } = useContext(ToastContext);
  const { setLoaded } = useLoaded();
  const { leasedAssetInfo } = useContext(LeasedAssetContext);
  const { setLeasedAssets } = leasedAssetInfo;

  useEffect(() => {
    try {
      const getLeasedData = async () => {
        const { data } = handleNull(await api.get('/assets/leased/details'));
        setLeasedAssets(data);
        setLoaded(true);
      };
      getLeasedData();
    } catch (e) {
      handleError(e);
    }
    return () => setLoaded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, handleError, setLoaded]);

  const instructions = [
    'Add to the list all business personal property leased or rented by you.',
    'To make changes or remove items click on the item row in the table below.',
    'Go to Step 5 when finished.',
    'If you do not have any leased or rented items please continue to the next step.',
  ];

  return (
    <>
      <CardWrapper>
        <InstructionsList instructions={instructions} />
      </CardWrapper>

      <LeasedAssetDataTable />
    </>
  );
};

export default LeasedAssetPage;
